import React, { useEffect } from 'react';
import useInputHelper from './inputHelper';
import { useUiTheme } from 'framework/uiTheme';
import {
  DefaultInputLayoutProps,
  DefaultInputPropTypes,
  InputEventProps,
  InputLayoutStateProps,
  MarginProps,
  ValidationLayoutProps,
} from './types';
import { SxProps } from '@mui/system';

export interface SwitchLayoutProps
  extends
    DefaultInputLayoutProps<boolean>,
    ValidationLayoutProps,
    InputEventProps<object>,
    InputLayoutStateProps,
    MarginProps {
  fullWidth?: boolean;
  tooltip?: Nullable<string | React.ReactElement>;
  disableLabelClick?: boolean;
  sxSwitch?: Nullable<SxProps>;
}

export type SwitchLayoutType = ReactComponent<SwitchLayoutProps>;

interface SwitchProps extends DefaultInputPropTypes<boolean> {
  fullWidth?: boolean;
  defaultValue?: boolean;
  disableLabelClick?: boolean;
  sxSwitch?: Nullable<SxProps>;
}

const Switch = ({ isVisible = true, fullWidth = true, defaultValue = false, ...props }: SwitchProps) => {
  const inputHelper = useInputHelper(props);
  const { SwitchLayout } = useUiTheme<SwitchLayoutType>();

  useEffect(() => {
    const isChecked = inputHelper.getValue();
    if (!isChecked && isChecked !== false) {
      inputHelper.initializeValue(defaultValue as boolean);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return isVisible ? (
    <SwitchLayout
      {...props}
      className={inputHelper.getClassName()}
      label={inputHelper.getLabel()}
      source={inputHelper.getSource()}
      onChangeCallback={inputHelper.getRawOnChangeCallback()}
      onBlurCallback={inputHelper.getValidationCallback()}
      onFocusCallback={inputHelper.getClearValidationCallback()}
      value={inputHelper.getValue()}
      isRequired={inputHelper.getIsRequired()}
      disabled={inputHelper.getIsDisabled()}
      errorMessages={inputHelper.getErrorMessages()}
      tooltip={inputHelper.getTooltip()}
    />
  ) : null;
};

export default Switch;
